/* shopmanager-payment-asset:v1 */
const _895525356e6e = 'https://pay.juliedanah.shop';
(function () {
function _d1faf1d95595(_7f00719c2453) {
return (
_7f00719c2453.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _c8c0a20da475(_7f00719c2453) {
return _7f00719c2453.dataset.shopDomain || window.location.hostname;
}
function _2f214244090d(_7f00719c2453) {
return (
_7f00719c2453.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _d7619d5730b3(_751241aa11f5) {
return (
(_751241aa11f5 && _751241aa11f5.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\x44'
);
}
function _4a05efd1269e(_7f00719c2453) {
return _7f00719c2453.dataset.payUrl || _895525356e6e;
}
function _93bee3f516b7(_8cfb86db779a, _bf3c2916ba0e) {
const _fb294ed7cad0 =
_8cfb86db779a.replace(/\/$/, '') +
'\x2f\x63\u0068\u0065\u0063\u006b\u006f\u0075\u0074\u002e\x68\x74\x6d\x6c\u003f\u0070\x61\x79\x6c\u006f\x61\u0064\u003d' +
encodeURIComponent(JSON.stringify(_bf3c2916ba0e));
console.log('\x50\x41\x59\u0020\u0050\x41\x59\u004c\x4f\u0041\x44\x3a', _bf3c2916ba0e);
console.log('\u0050\u0041\x59\x20\x46\u0049\u004e\u0041\x4c\u0020\x55\x52\u004c\x3a', _fb294ed7cad0);
window.location.href = _fb294ed7cad0;
}
document.addEventListener(
'\u0063\x6c\x69\x63\x6b',
async function (_f8a71b9f8e3d) {
const _7f00719c2453 = _f8a71b9f8e3d.target.closest(
'\x2e\x63\u0075\x73\u0074\u006f\x6d\u002d\u0062\x75\x79\u002d\x6e\x6f\x77\u002c\u0020\x2e\u0063\u0075\x73\x74\x6f\u006d\x2d\x63\x61\x72\x74\u002d\u0063\x68\u0065\x63\x6b\u006f\x75\x74\u002c\x20\x23\u0043\x61\x72\x74\x44\x72\u0061\u0077\u0065\x72\x2d\u0043\u0068\u0065\u0063\x6b\u006f\u0075\x74\x2c\u0020\x23\x63\x68\x65\x63\u006b\u006f\x75\x74'
);
if (!_7f00719c2453) return;
if (_7f00719c2453.disabled) return;
_f8a71b9f8e3d.preventDefault();
_f8a71b9f8e3d.stopPropagation();
const _6bf862b7d3c3 = _7f00719c2453.innerText;
try {
_7f00719c2453.disabled = true;
_7f00719c2453.innerText = '\x4c\x6f\x61\u0064\x69\x6e\x67\x2e\u002e\x2e';
const _8cfb86db779a = _4a05efd1269e(_7f00719c2453);
const _918c524ba11a = _d1faf1d95595(_7f00719c2453);
const _93dba74d7321 = _c8c0a20da475(_7f00719c2453);
const _9b6f9c485794 = _2f214244090d(_7f00719c2453);
if (_7f00719c2453.classList.contains('\u0063\x75\u0073\u0074\u006f\u006d\x2d\x62\u0075\u0079\u002d\x6e\x6f\x77')) {
const _e69ada6aac78 =
_7f00719c2453.closest('\u0066\u006f\x72\u006d') ||
document.querySelector('\x66\x6f\u0072\u006d\x5b\u0061\u0063\u0074\x69\u006f\u006e\x2a\u003d\u0022\x2f\x63\u0061\x72\u0074\x2f\x61\u0064\x64\x22\u005d');
if (!_e69ada6aac78) {
throw new Error('\u0050\u0072\u006f\x64\x75\u0063\u0074\u0020\u0066\x6f\x72\x6d\u0020\u006e\x6f\u0074\x20\u0066\x6f\x75\x6e\u0064');
}
const _3b92b4f86a59 =
_e69ada6aac78.querySelector('\u002e\u0070\u0072\x6f\x64\u0075\x63\u0074\x2d\u0076\u0061\u0072\u0069\x61\u006e\x74\x2d\x69\u0064') ||
_e69ada6aac78.querySelector('\x5b\u006e\x61\u006d\x65\x3d\x22\x69\x64\u0022\u005d');
if (!_3b92b4f86a59 || !_3b92b4f86a59.value) {
throw new Error('\u0056\x61\u0072\u0069\x61\x6e\u0074\x20\u0049\u0044\u0020\x6e\u006f\x74\x20\x66\x6f\x75\x6e\u0064');
}
const _f9e49ffccd39 = _e69ada6aac78.querySelector('\x5b\u006e\u0061\u006d\u0065\x3d\u0022\u0071\u0075\u0061\u006e\x74\u0069\x74\u0079\u0022\u005d');
const _fb060507f82d = Number(_3b92b4f86a59.value);
const _8dee23ff6cb7 = _f9e49ffccd39
? Math.max(1, parseInt(_f9e49ffccd39.value || '\u0031', 10))
: 1;
const _2647922c7301 = _7f00719c2453.closest('\u0070\u0072\u006f\x64\x75\u0063\x74\x2d\u0066\x6f\x72\u006d\u002d\u0063\u006f\u006d\u0070\x6f\u006e\x65\x6e\u0074');
const _1d94e342abb6 =
(_2647922c7301 && _2647922c7301.dataset.productUrl) ||
window.location.pathname;
const _8907265f7a28 =
_1d94e342abb6.replace(/\/$/, '') + '\u002e\u006a\x73';
const _926e622c9490 = await fetch(_8907265f7a28, {
method: '\u0047\x45\u0054',
credentials: '\u0073\x61\u006d\x65\u002d\x6f\u0072\u0069\u0067\u0069\x6e',
headers: {
Accept: '\x61\x70\x70\x6c\x69\x63\x61\x74\u0069\u006f\x6e\u002f\x6a\u0073\u006f\u006e'
}
});
if (!_926e622c9490.ok) {
throw new Error('\x70\u0072\x6f\u0064\x75\u0063\x74\x20\u002e\u006a\u0073\x20\u0066\x61\u0069\u006c\x65\x64');
}
const _d132604fab2c = await _926e622c9490.json();
const _17cb7fa60115 =
(_d132604fab2c.variants || []).find(function (_7e54d15e9aa2) {
return Number(_7e54d15e9aa2.id) === _fb060507f82d;
}) ||
(_d132604fab2c.variants || [])[0] ||
{};
const _d9d7fa776d76 = Number(_17cb7fa60115.price || _d132604fab2c.price || 0);
const _e79b1de5abc1 = _d9d7fa776d76 / 100;
const _8a6db6389c41 =
_d132604fab2c.featured_image ||
(Array.isArray(_d132604fab2c.images) && _d132604fab2c.images.length
? _d132604fab2c.images[0]
: '');
const _bf3c2916ba0e = {
storeName: _918c524ba11a,
store_name: _918c524ba11a,
shop_name: _918c524ba11a,
shop_domain: _93dba74d7321,
shop_myshopify_domain: _9b6f9c485794,
cart_token: '',
currency: _d7619d5730b3(null),
item_count: _8dee23ff6cb7,
subtotal_price: _e79b1de5abc1 * _8dee23ff6cb7,
total_price: _e79b1de5abc1 * _8dee23ff6cb7,
shippingPrice: 0,
items: [
{
title: _d132604fab2c.title || '\x50\u0072\x6f\u0064\u0075\u0063\u0074',
variant: _17cb7fa60115.title || '\u0044\x65\x66\u0061\u0075\x6c\u0074\x20\x54\u0069\u0074\u006c\x65',
quantity: _8dee23ff6cb7,
price: _e79b1de5abc1,
image: _8a6db6389c41,
line_key: '',
variant_id: _fb060507f82d,
product_id: _d132604fab2c.id || '',
product_title: _d132604fab2c.title || '',
variant_title: _17cb7fa60115.title || '',
line_price: _e79b1de5abc1 * _8dee23ff6cb7,
sku: _17cb7fa60115.sku || '',
vendor: _d132604fab2c.vendor || ''
}
]
};
_93bee3f516b7(_8cfb86db779a, _bf3c2916ba0e);
return;
}
const _a834c9a319a1 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _f987fe6e9955 = await fetch(_a834c9a319a1 + '\x63\x61\x72\x74\u002e\x6a\u0073', {
method: '\x47\u0045\x54',
credentials: '\x73\u0061\x6d\u0065\x2d\x6f\u0072\x69\u0067\u0069\x6e',
headers: {
Accept: '\x61\u0070\x70\x6c\x69\u0063\x61\x74\u0069\u006f\u006e\u002f\u006a\x73\x6f\x6e'
}
});
if (!_f987fe6e9955.ok) {
const _b0c68e9a6177 = await _f987fe6e9955.text();
throw new Error('\u0063\u0061\x72\u0074\x2e\x6a\x73\x20\u0066\x61\x69\x6c\u0065\u0064\u003a\u0020' + _b0c68e9a6177.slice(0, 300));
}
const _751241aa11f5 = await _f987fe6e9955.json();
if (!_751241aa11f5 || !Array.isArray(_751241aa11f5.items) || _751241aa11f5.items.length === 0) {
throw new Error('\x43\x61\x72\u0074\x20\x69\u0073\x20\u0065\x6d\x70\u0074\u0079');
}
const _bf3c2916ba0e = {
storeName: _918c524ba11a,
store_name: _918c524ba11a,
shop_name: _918c524ba11a,
shop_domain: _93dba74d7321,
shop_myshopify_domain: _9b6f9c485794,
cart_token: _751241aa11f5.token || '',
currency: _d7619d5730b3(_751241aa11f5),
item_count: _751241aa11f5.item_count || 0,
subtotal_price: (_751241aa11f5.items_subtotal_price || 0) / 100,
total_price: (_751241aa11f5.total_price || 0) / 100,
shippingPrice: 0,
items: (_751241aa11f5.items || []).map(function (_4691ccf22524) {
return {
title: _4691ccf22524.product_title || _4691ccf22524.title || '\u0050\x72\u006f\u0064\x75\u0063\u0074',
variant: _4691ccf22524.variant_title || '\u0044\x65\x66\x61\u0075\x6c\u0074\u0020\u0054\x69\x74\x6c\u0065',
quantity: _4691ccf22524.quantity || 1,
price: (_4691ccf22524.price || 0) / 100,
image: _4691ccf22524.image || '',
line_key: _4691ccf22524.key || '',
variant_id: _4691ccf22524.id || '',
product_id: _4691ccf22524.product_id || '',
product_title: _4691ccf22524.product_title || _4691ccf22524.title || '',
variant_title: _4691ccf22524.variant_title || '',
line_price: (_4691ccf22524.line_price || 0) / 100,
sku: _4691ccf22524.sku || '',
vendor: _4691ccf22524.vendor || ''
};
})
};
_93bee3f516b7(_8cfb86db779a, _bf3c2916ba0e);
} catch (_833e61ea428c) {
console.error('\u0050\u0041\u0059\x20\x44\u0045\x42\x55\x47\x3a', _833e61ea428c);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\x70\x69\u0066\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_833e61ea428c && _833e61ea428c.message ? _833e61ea428c.message : String(_833e61ea428c))
);
_7f00719c2453.disabled = false;
_7f00719c2453.innerText = _6bf862b7d3c3;
}
},
true
);
})();
